const standardizePhoneNumber = (phoneNumber, countryDialingCode) => {
  let cleanedPhoneNumber = phoneNumber.replace(/\D/g, "");
  if (cleanedPhoneNumber[0] === "0" && !!countryDialingCode) {
    cleanedPhoneNumber = String(countryDialingCode) + cleanedPhoneNumber.slice(1);
  }
  if (cleanedPhoneNumber[0] !== "+") {
    cleanedPhoneNumber = "+" + cleanedPhoneNumber;
  }
  return cleanedPhoneNumber;
};
const localizePhoneNumber = (standardizedPhoneNumber, countryDialingCode) => {
  let cleanedPhoneNumber = standardizedPhoneNumber;
  if (cleanedPhoneNumber[0] === "+") {
    cleanedPhoneNumber = cleanedPhoneNumber.replace("+" + countryDialingCode, "0");
  }
  return cleanedPhoneNumber;
};
export {
  localizePhoneNumber,
  standardizePhoneNumber
};
